import { useOutletContext, useParams } from "react-router-dom"
import BidsHeader from "./bidsHeader"
import ListingBody from "./listingBody"
import React, { useCallback, useEffect, useState } from "react";
import Paginate from "../../listAuction/paginate";
import ToastMeassage from "../../../../CommonComponent/toastMeasseage";
import { dataService } from "../../../../services/dataService";

export default function BidsList(){

    const outletContext = useOutletContext();
    const {id, uid} = useParams();

    const { searchParam, setSearchParam, loading, setIsSearched,
        currentSortColumn,setCurrentSortColumn,auctionData, socketConn } = outletContext;

    const [searchValue, setSearchValue]=useState("");
    const [showExoprtToastMsg, setShowExportToastMsg]=useState(false)
    const [bids,setBidss]=useState([])
    const [bidsInfo,setBidsInfo]=useState({})
    const [loadBids,setLoadBids]=useState(true);

    const bidsFetchHandler = useCallback(async (page) =>{
        setLoadBids(true)
        let endpointBids = `per_page=${10}&page=${page ? page : '1'}`
    
        if(searchParam.get('sort')!==null){
            endpointBids += `&sort_by=${String(searchParam.get('sort'))}&sort_order=${String
            (searchParam.get('order'))}`
        }
        if(searchParam.get('search_term')!==null){
            endpointBids += `&search_keyword=${searchParam.get('search_term')}`
        }
        if(searchParam.get('bidsExport') !==null){
            endpointBids += `&export=True`
        }
        const response = await dataService.getAllBids(uid,endpointBids);
        setLoadBids(false)
        if(response.error===false){
            setBidss(response.data.data);
            setBidsInfo(response.data);
        }
        setBidsInfo(response.data);
        setIsSearched(false)
        if(response.data?.csv_url){
            window.location.href= response.data?.csv_url;
            let params = Object.fromEntries(searchParam);
            delete params.bidsExport
            setSearchParam(params)
        }
            
    }, [searchParam])

    useEffect(() => {
        if (socketConn) {
            socketConn.on('deleteBid', (message) => {
                if (message.success === true) {
                    bidsFetchHandler(searchParam.get('page') || 1);
                    setShowExportToastMsg(true);
                    setTimeout(() => {
                        setShowExportToastMsg(false);
                    }, 5000);
                }
            });

            return () => {
                socketConn.off('deleteBid');
            };
        }
    }, [socketConn, bidsFetchHandler, searchParam]);

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParam)
        setSearchParam({ ...params, page: pageNum.selected + 1 })
    }

    useEffect(()=>{
        setLoadBids(true);
    },[])

    useEffect(() => {
        setSearchValue(
            searchParam.get('search_term')
                ? decodeURIComponent(searchParam.get('search_term'))
                : ''
        );
    }, [searchParam]);

    /**
     * The function `handleSearch` takes in an event, a key, and a value, and updates the search
     * parameters based on the key-value pair.
     */
    const handleSearch=(e, key, value)=>{
        e.preventDefault();
        let params = Object.fromEntries(searchParam);
        params.page = 1
        if(key === 'search_term') {
            // eslint-disable-next-line security/detect-object-injection
            params[key] = encodeURIComponent(value); 
        }else {
            // eslint-disable-next-line security/detect-object-injection
            params[key] = value
        }
        if(params['search_term'] === ''){ 
            delete params.search_term
            setLoadBids(true);
        }
        setSearchParam({ ...params})
    }

    /**
     * The function `handleSort` is used to update the search parameters based on the sorting key and
     * order.
     */
    const handleSort=(e,key)=>{
        let params = Object.fromEntries(searchParam);
        if(searchParam.get('sort') === false || searchParam.get('sort') === null) {
            params['sort'] = `${key}`
            params['order'] = `asc`
            setCurrentSortColumn({
                key: key,
                order: 'asc'
            });
        }else {
            if(searchParam.get('sort').includes(key)) 
            {
                if(searchParam.get('order')==='asc') {
                    params['order'] = `desc`
                    setCurrentSortColumn({
                        key: key,
                        order: 'desc'
                    });
                }else{
                    params['order'] = `asc`
                    setCurrentSortColumn({
                        key: key,
                        order: 'asc'
                    });
                }
            }
            else {
                params['sort'] = key
                params['order'] = `asc`
                setCurrentSortColumn({
                    key: key,
                    order: 'asc'
                });
            }
        }
        setSearchParam({ ...params})
    }

    useEffect(()=>{
        bidsFetchHandler(searchParam.get('page'));
    },[searchParam])

    return(
        <div>
            <BidsHeader searchParam={searchParam} searchValue={searchValue} setSearchParam={setSearchParam}
                setSearchValue={setSearchValue} handleSearch={handleSearch} bidsInfo={bidsInfo} 
                setShowExportToastMsg={setShowExportToastMsg} bids={bids} />
            {showExoprtToastMsg && <ToastMeassage message={'Export complete'}/>}

            <ListingBody currentSortColumn={currentSortColumn} handleSort={handleSort} auctionData={auctionData}
                searchParam={searchParam} bids={bids} searchValue={searchValue} loadBids={loadBids} loading={loading} />
            {(bidsInfo?.current_page <= bidsInfo?.total_pages) &&
            <div className='pt-[80px]'>
                <Paginate totalPageNumber={Math.ceil(bidsInfo.total_records_found/10)}
                    selectedPageNumber={Number(searchParam.get('page')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber} />
            </div>
            }
        </div>
    )
}